function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", null);

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "Layer_1",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 512 512",
  style: {
    "enableBackground": "new 0 0 512 512"
  },
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  style: {
    "fill": "#FFD15C"
  },
  points: "510.933,58.667 458.667,50.133 450.133,0 442.667,51.2 393.6,58.667 442.667,66.133  450.133,117.333 458.667,67.2 \t"
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    "fill": "#FFD15C"
  },
  points: "88.533,0 86.4,20.267 65.067,23.467 85.333,26.667 88.533,46.933 92.8,26.667  113.067,23.467 91.733,20.267 \t"
})), /*#__PURE__*/React.createElement("polygon", {
  style: {
    "fill": "#CDD6E0"
  },
  points: "59.733,65.067 54.4,28.8 49.067,65.067 13.867,70.4 49.067,76.8 54.4,113.067 59.733,76.8  97.067,70.4 "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    "fill": "#84DBFF"
  },
  points: "336,215.467 270.933,91.733 244.267,91.733 171.733,215.467 "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    "fill": "#54C0EB"
  },
  points: "419.2,91.733 270.933,91.733 336,215.467 "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    "fill": "#84DBFF"
  },
  points: "508.8,215.467 420.267,91.733 419.2,91.733 336,215.467 "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    "fill": "#F2F2F2"
  },
  points: "254.933,512 336,215.467 171.733,215.467 "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    "fill": "#54C0EB"
  },
  points: "244.267,91.733 90.667,91.733 171.733,215.467 "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    "fill": "#84DBFF"
  },
  points: "90.667,91.733 89.6,91.733 1.067,215.467 171.733,215.467 "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    "fill": "#54C0EB"
  },
  points: "508.8,215.467 254.933,512 1.067,215.467 171.733,215.467 254.933,512 336,215.467 "
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  style: {
    "fill": "#FFFFFF"
  },
  points: "336,182.4 331.733,210.133 302.933,214.4 331.733,218.667 336,248.533 340.267,218.667  369.067,214.4 340.267,210.133 \t"
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    "fill": "#FFFFFF"
  },
  points: "126.933,120.533 122.667,148.267 93.867,152.533 121.6,156.8 126.933,186.667  131.2,157.867 160,152.533 131.2,148.267 \t"
})), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);

export default __webpack_public_path__ + "static/media/diamond.e1926036.svg";
export { SvgComponent as ReactComponent };